import { usePageSeo } from '../hooks/usePageSeo';
import RichContent from './RichContent';
import LoadingIndicator from './LoadingIndicator';
import '../pages/StaticLegal.css';

/**
 * @param {{
 *   pageTitle: string,
 *   contentHtml: string,
 *   seoPath: string,
 *   brand?: string,
 *   metaDescription?: string,
 *   publicBase?: string,
 *   loading?: boolean
 * }} props
 */
export default function LegalPage({
  pageTitle,
  contentHtml,
  seoPath,
  brand = 'Invincible NGO',
  metaDescription = '',
  publicBase = '',
  loading = false
}) {
  usePageSeo({
    title: `${pageTitle} | ${brand}`,
    description: metaDescription,
    canonical: publicBase && seoPath ? `${publicBase}${seoPath}` : undefined
  });

  if (loading) {
    return (
      <div className="legal-page">
        <LoadingIndicator label="Loading..." />
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="legal-card">
        <h1>{pageTitle}</h1>
        <RichContent content={contentHtml} className="legal-rich" stripQuillBlankParagraphs />
      </div>
    </div>
  );
}
